/* ============================================================
   MATILDA · tema Shopify — comportamiento (JS sin dependencias)
   Hace lo mismo que los componentes de la web v4: intro, cabecera transparente sobre el banner,
   menús, búsqueda en línea, la hormiga de los selectores, pestañas, baraja de postales, videos a la
   vista, cajón «El look de…», ficha (tallas, cantidad, agregar, avísame, cupón), bolsa lateral con
   la API de secciones, «Combínalo con» que rota, «Ver por», catálogo de corrido, filtros y orden.
   ============================================================ */
(function () {
  "use strict";

  var M = window.MATILDA || { rutas: {}, textos: {} };
  var $ = function (sel, raiz) { return (raiz || document).querySelector(sel); };
  var $$ = function (sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); };
  var reducido = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var punteroFino = matchMedia("(hover: hover) and (pointer: fine)").matches;

  function pesos(centavos) {
    return "$" + Math.round(centavos / 100).toLocaleString("es-CO", { maximumFractionDigits: 0 });
  }

  /* ── Cajones (bolsa, look, filtros) ───────────────────────── */
  var abiertos = [];
  function abrirCajon(caja) {
    if (!caja || abiertos.indexOf(caja) > -1) return;
    var fondo = $("button[data-cerrar]", caja);
    var panel = $("[data-panel]", caja);
    caja.classList.remove("pointer-events-none");
    caja.inert = false;
    if (fondo) { fondo.classList.remove("opacity-0"); fondo.classList.add("opacity-100"); }
    if (panel) { panel.classList.remove("translate-x-full"); panel.classList.add("translate-x-0"); }
    abiertos.push(caja);
    document.body.style.overflow = "hidden";
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 30);
  }
  function cerrarCajon(caja) {
    var i = abiertos.indexOf(caja);
    if (i < 0) return;
    var fondo = $("button[data-cerrar]", caja);
    var panel = $("[data-panel]", caja);
    caja.classList.add("pointer-events-none");
    caja.inert = true;
    if (fondo) { fondo.classList.add("opacity-0"); fondo.classList.remove("opacity-100"); }
    if (panel) { panel.classList.add("translate-x-full"); panel.classList.remove("translate-x-0"); }
    abiertos.splice(i, 1);
    if (!abiertos.length && !menuAbierto) document.body.style.overflow = "";
    caja.dispatchEvent(new CustomEvent("matilda:cerrado"));
  }
  document.addEventListener("click", function (e) {
    var cerrar = e.target.closest("[data-cerrar]");
    if (!cerrar) return;
    var caja = cerrar.closest("[data-bolsa], [data-cajon-look], [data-filtros]");
    if (caja) cerrarCajon(caja);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && abiertos.length) cerrarCajon(abiertos[abiertos.length - 1]);
  });

  /* ── Intro: el logo y la hormiga; sale a 1,35 s ───────────── */
  var intro = $(".intro");
  if (intro && document.documentElement.dataset.intro !== "vista") {
    setTimeout(function () {
      intro.dataset.fase = "salida";
      var h = $(".intro-hormiga", intro);
      if (h) h.removeAttribute("data-camina");
    }, 1350);
    setTimeout(function () { intro.remove(); }, 2200);
  }

  /* ── La hormiga de los selectores: camina hasta la opción activa ── */
  function iniciarSelector(fila, alCambiar) {
    var hormiga = $(".selector-hormiga", fila);
    var anterior = null;
    var reloj = null;
    function medir() {
      var activa = $('[aria-checked="true"]', fila);
      if (!activa || !hormiga) return;
      var r = activa.getBoundingClientRect();
      var f = fila.getBoundingClientRect();
      if (!r.width && !f.width) return;
      var centro = r.left - f.left + r.width / 2;
      var sentido = 1;
      if (anterior !== null && anterior !== centro) {
        sentido = centro > anterior ? 1 : -1;
        hormiga.setAttribute("data-camina", "");
        clearTimeout(reloj);
        reloj = setTimeout(function () { hormiga.removeAttribute("data-camina"); }, 520);
      } else if (hormiga.dataset.sentido) {
        sentido = Number(hormiga.dataset.sentido);
      }
      hormiga.dataset.sentido = sentido;
      anterior = centro;
      hormiga.style.transform = "translateX(calc(" + centro + "px - 50%)) scaleX(" + sentido + ")";
      hormiga.hidden = false;
    }
    fila.addEventListener("click", function (e) {
      var op = e.target.closest("[data-valor]");
      if (!op || !fila.contains(op)) return;
      $$("[data-valor]", fila).forEach(function (b) { b.setAttribute("aria-checked", b === op ? "true" : "false"); });
      medir();
      if (alCambiar) alCambiar(op.dataset.valor);
    });
    if ("ResizeObserver" in window) new ResizeObserver(medir).observe(fila);
    medir();
    return { medir: medir, elegir: function (v) {
      $$("[data-valor]", fila).forEach(function (b) { b.setAttribute("aria-checked", b.dataset.valor === String(v) ? "true" : "false"); });
      medir();
    } };
  }

  /* ── Cabecera ─────────────────────────────────────────────── */
  var cabecera = $("[data-cabecera]");
  var barra = $("[data-barra-cabecera]");
  var menu = $("[data-menu]");
  var menuBoton = $("[data-menu-boton]");
  var menuAbierto = false;
  var sobreHero = false;
  var desplegado = null;
  var buscando = false;

  function pintarBarra() {
    if (!barra) return;
    var transparente = barra.hasAttribute("data-transparente") && sobreHero && !menuAbierto && !desplegado;
    if (transparente) barra.setAttribute("data-sobre-hero", "");
    else barra.removeAttribute("data-sobre-hero");
  }
  var centinela = document.getElementById("hero-centinela");
  if (centinela && barra && "IntersectionObserver" in window) {
    new IntersectionObserver(function (e) { sobreHero = e[0].isIntersecting; pintarBarra(); }, { rootMargin: "-72px 0px 0px 0px", threshold: 0 }).observe(centinela);
  }

  function abrirMenu(v) {
    if (!menu) return;
    menuAbierto = v;
    if (v) { menu.setAttribute("data-abierto", ""); menu.inert = false; document.body.style.overflow = "hidden"; }
    else { menu.removeAttribute("data-abierto"); menu.inert = true; if (!abiertos.length) document.body.style.overflow = ""; }
    if (menuBoton) {
      menuBoton.setAttribute("aria-expanded", v ? "true" : "false");
      menuBoton.setAttribute("aria-label", v ? menuBoton.dataset.etiquetaCerrar : menuBoton.dataset.etiquetaAbrir);
      $("[data-icono-abrir]", menuBoton).hidden = v;
      $("[data-icono-cerrar]", menuBoton).hidden = !v;
    }
    pintarBarra();
  }
  if (menuBoton) menuBoton.addEventListener("click", function () { abrirMenu(!menuAbierto); });
  var menuBuscar = $("[data-menu-buscar]");
  if (menuBuscar) menuBuscar.addEventListener("click", function () {
    abrirMenu(true);
    var campo = $("[data-menu-campo]");
    if (campo) setTimeout(function () { campo.focus(); }, 60);
  });

  function desplegar(id) {
    desplegado = id;
    $$("[data-desplegar]").forEach(function (b) {
      var abierto = b.dataset.desplegar === id;
      b.setAttribute("aria-expanded", abierto ? "true" : "false");
      if (abierto) b.setAttribute("data-abierto", ""); else b.removeAttribute("data-abierto");
      var caret = $(".caret", b);
      if (caret) caret.classList.toggle("rotate-180", abierto);
    });
    $$("[data-desplegable]").forEach(function (d) { d.hidden = d.dataset.desplegable !== id; });
    pintarBarra();
  }
  $$("[data-desplegar]").forEach(function (b) {
    if (b.hasAttribute("data-activo")) b.setAttribute("data-activo-original", "");
    b.addEventListener("click", function () {
      desplegar(desplegado === b.dataset.desplegar ? null : b.dataset.desplegar);
      // el subrayado se ve en la opción desplegada o en la de la página actual
      $$("[data-desplegar]").forEach(function (x) {
        if (x.dataset.desplegar === desplegado || x.hasAttribute("data-activo-original")) x.setAttribute("data-activo", "");
        else x.removeAttribute("data-activo");
      });
    });
  });

  var busqueda = $("[data-busqueda-linea]");
  var lupa = $("[data-lupa]");
  function buscar(v) {
    buscando = v;
    if (!busqueda) return;
    var campo = $("input[name=q]", busqueda);
    if (v) { busqueda.setAttribute("data-abierta", ""); busqueda.setAttribute("aria-hidden", "false"); campo.tabIndex = 0; setTimeout(function () { campo.focus(); }, 30); }
    else { busqueda.removeAttribute("data-abierta"); busqueda.setAttribute("aria-hidden", "true"); campo.tabIndex = -1; }
    if (lupa) lupa.setAttribute("aria-expanded", v ? "true" : "false");
  }
  if (lupa && busqueda) lupa.addEventListener("click", function () {
    var campo = $("input[name=q]", busqueda);
    if (buscando && campo.value.trim()) busqueda.submit();
    else buscar(!buscando);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (menuAbierto) abrirMenu(false);
    if (desplegado) { desplegar(null); $$("[data-desplegar]").forEach(function (x) { if (!x.hasAttribute("data-activo-original")) x.removeAttribute("data-activo"); }); }
    if (buscando) buscar(false);
  });
  document.addEventListener("pointerdown", function (e) {
    if (!barra || barra.contains(e.target)) return;
    if (desplegado) { desplegar(null); $$("[data-desplegar]").forEach(function (x) { if (!x.hasAttribute("data-activo-original")) x.removeAttribute("data-activo"); }); }
    if (buscando) buscar(false);
  });

  /* ── Pestañas de la portada ───────────────────────────────── */
  $$("[data-pestanas]").forEach(function (caja) {
    var fila = $("[data-selector]", caja);
    if (!fila) return;
    iniciarSelector(fila, function (valor) {
      $$("[data-panel]", caja).forEach(function (p) { p.hidden = p.dataset.panel !== valor; });
    });
  });

  /* ── Baraja de postales del banner ────────────────────────── */
  $$("[data-baraja]").forEach(function (baraja) {
    var cartas = $$("[data-carta]", baraja);
    var lugar = $("[data-baraja-lugar]", baraja);
    var fuera = 0;
    var inicio = null;
    function pintar() {
      cartas.forEach(function (c, j) {
        var k = j - fuera;
        if (k < 0 || k > 2) { c.hidden = true; return; }
        c.hidden = false;
        c.style.setProperty("--k", k);
        c.style.zIndex = 20 - k;
        c.style.transform = "";
        c.removeAttribute("data-arrastrando");
      });
      var actual = cartas[fuera];
      if (lugar && actual) { lugar.textContent = actual.dataset.lugar; lugar.href = actual.dataset.enlace || "#"; }
    }
    function descartar() { fuera = fuera + 1 >= cartas.length ? 0 : fuera + 1; pintar(); }
    baraja.addEventListener("pointerdown", function (e) {
      var c = e.target.closest("[data-carta]");
      if (!c || c !== cartas[fuera]) return;
      inicio = { x: e.clientX, y: e.clientY, carta: c };
      c.setPointerCapture(e.pointerId);
    });
    baraja.addEventListener("pointermove", function (e) {
      if (!inicio) return;
      var dx = e.clientX - inicio.x, dy = e.clientY - inicio.y;
      inicio.carta.setAttribute("data-arrastrando", "");
      inicio.carta.style.transform = "translate(" + dx + "px, " + dy + "px) rotate(" + dx / 12 + "deg)";
    });
    function soltar(e) {
      if (!inicio) return;
      var dx = e.clientX - inicio.x;
      inicio.carta.removeAttribute("data-arrastrando");
      inicio.carta.style.transform = "";
      inicio = null;
      if (Math.abs(dx) > 60) descartar();
    }
    baraja.addEventListener("pointerup", soltar);
    baraja.addEventListener("pointercancel", soltar);
    var siguiente = $("[data-baraja-siguiente]", baraja);
    if (siguiente) siguiente.addEventListener("click", descartar);
    pintar();
  });

  /* ── Videos: solo corren a la vista; con movimiento reducido queda el póster ── */
  if ("IntersectionObserver" in window && !reducido) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.3 });
    $$("video[data-reel]").forEach(function (v) { io.observe(v); });
  }

  /* ── Segunda foto de la tarjeta: se descarga al pasar el cursor ── */
  if (punteroFino) {
    document.addEventListener("pointerover", function (e) {
      var t = e.target.closest && e.target.closest(".tarjeta");
      if (!t) return;
      var img = $("img[data-hover-src]", t);
      if (!img) return;
      img.srcset = img.dataset.hoverSrcset || "";
      img.src = img.dataset.hoverSrc;
      img.removeAttribute("data-hover-src");
    });
  }

  /* ── «Combínalo con»: baraja las candidatas y muestra 4 distintas en cada visita ── */
  function hidratar(img) {
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute("data-srcset"); }
    if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute("data-src"); }
  }
  function barajar(raiz) {
    $$("[data-combinalo]", raiz).forEach(function (sec) {
      var grilla = $("[data-combinalo-grilla]", sec);
      var todas = $$("[data-candidata]", sec);
      for (var i = todas.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = todas[i]; todas[i] = todas[j]; todas[j] = t;
      }
      todas.forEach(function (c, k) {
        var visible = k < 4;
        c.hidden = !visible;
        if (visible) { $$("img[data-src]", c).forEach(hidratar); grilla.appendChild(c); }
      });
      grilla.classList.add("aparece");
    });
  }
  barajar(document);

  /* ── Bolsa (API de secciones) ─────────────────────────────── */
  var bolsa = $("[data-bolsa]");
  function pintarCuenta(n) {
    $$("[data-bolsa-cuenta]").forEach(function (b) { b.textContent = n; b.hidden = !n; });
    $$("[data-abrir-bolsa]").forEach(function (a) {
      a.setAttribute("aria-label", n === 1 ? M.textos.bolsaUno : String(M.textos.bolsa || "").replace("[n]", n));
    });
  }
  function pintarBolsa(html) {
    if (!bolsa || !html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var nuevo = $("[data-bolsa-panel]", doc);
    var actual = $("[data-bolsa-panel]", bolsa);
    if (!nuevo || !actual) return;
    actual.replaceWith(nuevo);
    barajar(nuevo);
    pintarCuenta(Number(nuevo.dataset.cuenta || 0));
  }
  function pedir(url, cuerpo) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(cuerpo) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  function agregar(items) {
    return pedir(M.rutas.agregar, { items: items, sections: "bolsa" }).then(function (d) {
      pintarBolsa(d.sections && d.sections.bolsa);
      abrirCajon(bolsa);
      return d;
    });
  }
  window.MATILDA.agregar = agregar;
  document.addEventListener("click", function (e) {
    var abrir = e.target.closest("[data-abrir-bolsa]");
    if (abrir && bolsa) { e.preventDefault(); abrirCajon(bolsa); return; }
    var linea = e.target.closest("[data-linea]");
    if (linea && bolsa && bolsa.contains(linea)) {
      linea.disabled = true;
      pedir(M.rutas.cambiar, { id: linea.dataset.linea, quantity: Number(linea.dataset.cantidad), sections: "bolsa" })
        .then(function (d) { pintarBolsa(d.sections && d.sections.bolsa); })
        .catch(function () { linea.disabled = false; });
    }
  });

  /* ── Cajón «El look de…» (Latinas) ────────────────────────── */
  $$("[data-latinas]").forEach(function (sec) {
    var looks = [];
    try { looks = JSON.parse($("[data-looks]", sec).textContent); } catch (e) {}
    var caja = $("[data-cajon-look]", sec);
    if (!caja || !looks.length) return;
    var plantilla = $("template[data-look-fila]", caja);
    var lista = $("[data-look-lista]", caja);
    var foto = $("[data-look-foto]", caja);
    var titulo = $("[data-look-titulo]", caja);
    var actual = null;
    var tallas = {};
    function variante(p) {
      var t = tallas[p.id];
      var v = p.variantes.filter(function (x) { return x.talla === t; })[0];
      return v || p.variantes.filter(function (x) { return x.disponible; })[0] || p.variantes[0];
    }
    function fila(p) {
      var li = plantilla.content.firstElementChild.cloneNode(true);
      $("[data-f-enlace]", li).href = p.url;
      var im = $("[data-f-img]", li);
      if (p.imagen) im.src = p.imagen; else im.remove();
      var tit = $("[data-f-titulo]", li);
      tit.href = p.url; tit.textContent = p.titulo;
      $("[data-f-precio]", li).innerHTML = "<span>" + pesos(p.precio) + "</span>" + (p.antes > p.precio ? '<s class="text-humo">' + pesos(p.antes) + "</s>" : "");
      var grupo = $("[data-f-tallas]", li);
      grupo.setAttribute("aria-label", p.titulo);
      if (!tallas[p.id]) { var d = p.variantes.filter(function (x) { return x.disponible; })[0]; tallas[p.id] = (d || p.variantes[0]).talla; }
      p.variantes.forEach(function (v) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "chip num";
        b.setAttribute("role", "radio");
        b.setAttribute("aria-checked", tallas[p.id] === v.talla ? "true" : "false");
        if (!v.disponible) b.setAttribute("data-agotada", "");
        b.textContent = v.talla;
        b.addEventListener("click", function () {
          tallas[p.id] = v.talla;
          $$("button", grupo).forEach(function (x) { x.setAttribute("aria-checked", x === b ? "true" : "false"); });
        });
        grupo.appendChild(b);
      });
      var aviso = $("[data-f-aviso]", li);
      $("[data-f-agregar]", li).addEventListener("click", function () {
        var v = variante(p);
        if (!v.disponible) { aviso.hidden = false; return; }
        aviso.hidden = true;
        agregar([{ id: v.id, quantity: 1 }]).catch(function () {});
      });
      li._prenda = p;
      li._aviso = aviso;
      return li;
    }
    function abrir(i) {
      actual = looks[i];
      if (!actual) return;
      titulo.innerHTML = "";
      titulo.appendChild(document.createTextNode(actual.quien ? "El look de " + actual.quien + " " : "El look "));
      if (actual.lugar) { var s = document.createElement("span"); s.className = "text-humo"; s.textContent = "· " + actual.lugar; titulo.appendChild(s); }
      if (actual.foto) { foto.src = actual.foto; foto.alt = actual.alt || ""; foto.hidden = false; } else foto.hidden = true;
      lista.innerHTML = "";
      actual.prendas.forEach(function (p) { lista.appendChild(fila(p)); });
      $$("[data-abrir-look]", sec).forEach(function (b) { b.setAttribute("aria-expanded", b.dataset.abrirLook === String(i) && b.classList.contains("ancla") ? "true" : "false"); });
      abrirCajon(caja);
    }
    sec.addEventListener("click", function (e) {
      var b = e.target.closest("[data-abrir-look]");
      if (b) abrir(Number(b.dataset.abrirLook));
    });
    $("[data-look-todo]", caja).addEventListener("click", function () {
      var items = [];
      $$("li", lista).forEach(function (li) {
        var v = variante(li._prenda);
        if (v.disponible) { items.push({ id: v.id, quantity: 1 }); li._aviso.hidden = true; }
        else li._aviso.hidden = false;
      });
      if (items.length) agregar(items).catch(function () {});
    });
    caja.addEventListener("matilda:cerrado", function () {
      $$(".ancla[aria-expanded]", sec).forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    });
  });

  /* ── Ficha: tallas, cantidad, agregar, avísame, cupón ─────── */
  $$("[data-ficha]").forEach(function (ficha) {
    var datos;
    try { datos = JSON.parse($("[data-ficha-datos]", ficha).textContent); } catch (e) { return; }
    var form = $("[data-ficha-form]", ficha);
    var entradaId = form && $("[data-variante]", form);
    var entradaCant = form && $("[data-cantidad]", form);
    var verCant = form && $("[data-cantidad-ver]", form);
    var texto = form && $("[data-agregar-texto]", form);
    var total = form && $("[data-agregar-total]", form);
    var aviso = $("[data-aviso]", ficha);
    var estado = $("[data-estado]", ficha);
    var avisame = document.getElementById("avisame-form");
    var avisameCuerpo = avisame && $("[data-avisame-cuerpo]", avisame);
    var avisameDetalle = avisame && $("[data-avisame-detalle]", avisame);
    var cantidad = 1;
    var actual = datos.variantes.filter(function (v) { return entradaId && v.id === Number(entradaId.value); })[0] || datos.variantes[0];
    var elegidas = actual ? actual.opciones.slice() : [];

    function pintarPrecio() {
      var caja = $("[data-ficha-precio] [data-precio]", ficha);
      if (caja) caja.innerHTML = "<span>" + pesos(actual.precio) + "</span>" + (actual.antes > actual.precio ? '<s class="text-humo">' + pesos(actual.antes) + "</s>" : "");
      var addi = $("[data-addi]", ficha);
      if (addi) {
        var cuotas = Number(addi.dataset.cuotas) || 6;
        var pesosValor = actual.precio / 100;
        addi.hidden = pesosValor < Number(addi.dataset.minimo || 0) || pesosValor > Number(addi.dataset.maximo || 1e12);
        var c = $("[data-addi-cuota]", addi);
        if (c) c.textContent = pesos(Math.round(actual.precio / cuotas));
      }
      var addiOficial = $("addi-product-widget", ficha);
      if (addiOficial) addiOficial.setAttribute("price", actual.precio / 100);
    }
    function pintarBoton() {
      if (!texto) return;
      if (actual && actual.disponible) {
        texto.textContent = M.textos.agregar;
        total.textContent = "· " + pesos(actual.precio * cantidad);
        total.className = "num hidden sm:inline";
      } else {
        texto.textContent = M.textos.avisame;
        total.textContent = "";
        total.className = "num hidden";
      }
      if (estado) estado.textContent = actual && actual.disponible ? M.textos.enStock : M.textos.sinStock;
    }
    function elegir() {
      var v = datos.variantes.filter(function (x) { return x.opciones.every(function (o, i) { return o === elegidas[i]; }); })[0];
      if (!v) return;
      actual = v;
      if (entradaId) entradaId.value = v.id;
      if (avisameDetalle) avisameDetalle.value = avisameDetalle.value.replace(/talla .*$/i, "talla " + v.titulo);
      if (aviso) aviso.hidden = true;
      pintarPrecio();
      pintarBoton();
      var q = new URLSearchParams(location.search);
      q.set("variant", v.id);
      history.replaceState(null, "", location.pathname + "?" + q.toString() + location.hash);
    }
    $$("[data-opcion]", ficha).forEach(function (fs) {
      var i = Number(fs.dataset.opcion);
      fs.addEventListener("click", function (e) {
        var b = e.target.closest("button[data-valor]");
        if (!b) return;
        elegidas[i] = b.dataset.valor;
        $$("button[data-valor]", fs).forEach(function (x) {
          var si = x === b;
          x.setAttribute("aria-pressed", si ? "true" : "false");
          x.classList.toggle("border-tinta", si);
          x.classList.toggle("bg-tinta", si);
          x.classList.toggle("text-papel", si);
          x.classList.toggle("border-linea", !si);
        });
        elegir();
      });
    });
    if (form) {
      $("[data-menos]", form).addEventListener("click", function () { cantidad = Math.max(1, cantidad - 1); entradaCant.value = cantidad; verCant.textContent = cantidad; pintarBoton(); });
      $("[data-mas]", form).addEventListener("click", function () { cantidad = Math.min(9, cantidad + 1); entradaCant.value = cantidad; verCant.textContent = cantidad; pintarBoton(); });
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!actual) return;
        if (!actual.disponible) {
          if (aviso) { aviso.textContent = M.textos.agotada; aviso.hidden = false; }
          if (avisameCuerpo) { avisameCuerpo.hidden = false; var c = $("input[type=email]", avisameCuerpo); if (c) c.focus(); }
          return;
        }
        var boton = $("[data-agregar]", form);
        boton.disabled = true;
        agregar([{ id: actual.id, quantity: cantidad }])
          .catch(function (err) { if (aviso) { aviso.textContent = (err && err.description) || M.textos.error; aviso.hidden = false; } })
          .then(function () { boton.disabled = false; });
      });
    }
    $$("[data-copiar]", ficha).forEach(function (b) {
      b.addEventListener("click", function () {
        var codigo = b.dataset.copiar;
        var hecho = function () { var t = b.textContent; b.textContent = M.textos.copiado; setTimeout(function () { b.textContent = t; }, 1600); };
        // Respaldo para navegadores sin permiso de portapapeles (iOS viejo, página sin foco)
        var aMano = function () {
          var area = document.createElement("textarea");
          area.value = codigo;
          area.setAttribute("readonly", "");
          area.style.cssText = "position:fixed;opacity:0;pointer-events:none";
          document.body.appendChild(area);
          area.select();
          try { if (document.execCommand("copy")) hecho(); } catch (e) {}
          area.remove();
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(codigo).then(hecho, aMano);
        else aMano();
      });
    });
    pintarPrecio();
  });

  /* ── Catálogo: «Ver por» (densidad), páginas de corrido, filtros y orden ── */
  var CLAVE = "matilda-densidad";
  var densidad = { m: 3, e: 4 };
  try { densidad = Object.assign(densidad, JSON.parse(localStorage.getItem(CLAVE) || "{}")); } catch (e) {}
  var esMovil = function () { return matchMedia("(max-width: 1023px)").matches; };
  function aplicarDensidad() {
    $$("[data-grilla]").forEach(function (g) { g.dataset.densidad = esMovil() ? densidad.m : densidad.e; });
  }
  $$("[data-densidad-selector]").forEach(function (fila) {
    var lado = fila.dataset.densidadSelector;
    var sel = iniciarSelector(fila, function (valor) {
      densidad[lado] = Number(valor);
      try { localStorage.setItem(CLAVE, JSON.stringify(densidad)); } catch (e) {}
      aplicarDensidad();
    });
    sel.elegir(densidad[lado]);
  });
  matchMedia("(max-width: 1023px)").addEventListener("change", aplicarDensidad);

  $$("[data-catalogo]").forEach(function (cat) {
    var grilla = $("[data-grilla]", cat);
    var seccion = cat.dataset.seccion;
    function siguiente() {
      var url = grilla && grilla.dataset.siguiente;
      if (!url) return;
      grilla.removeAttribute("data-siguiente");
      var u = new URL(url, location.origin);
      u.searchParams.set("section_id", seccion);
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var otra = $("[data-grilla]", doc);
        if (!otra) return;
        Array.prototype.slice.call(otra.children).forEach(function (t) { grilla.appendChild(t); });
        if (otra.dataset.siguiente) { grilla.dataset.siguiente = otra.dataset.siguiente; siguiente(); }
      }).catch(function () {});
    }
    siguiente();
    var ordenar = $("[data-ordenar]", cat);
    if (ordenar) ordenar.addEventListener("change", function () {
      var q = new URLSearchParams(location.search);
      q.set("sort_by", ordenar.value);
      q.delete("page");
      location.search = q.toString();
    });
    var filtros = $("[data-filtros]", cat);
    var abrir = $("[data-abrir-filtros]", cat);
    if (filtros && abrir) {
      abrir.addEventListener("click", function () { abrirCajon(filtros); abrir.setAttribute("aria-expanded", "true"); });
      filtros.addEventListener("matilda:cerrado", function () { abrir.setAttribute("aria-expanded", "false"); });
    }
  });
})();
